import http from 'plugins/axios';

export default {
  getList(data) {
    return http.get({
      // url: '/la/admin/current/get',
      url: '/financial-admin/current/list',
      data
    });
  },
  create(data) {
    return http.post({
      // url: '/la/admin/current/add',
      url: '/financial-admin/current/submit',
      data
    });
  },
  getInterest(data){
    return http.get({
      url:`/financial-admin/current/switch-conf`,
    })
  },
  setInterest(data){
    return http.post({
      url:`/financial-admin/current/switch-set`,
      data
    })
  },
  update(data) {
    return http.post({
      url: '/financial-admin/current/submit',
      data
    });
  },
  getCoinTypeList() {
    return http.get({
      url: '/la/admin/coin/allDisplay'
    });
  },
  getFinancialCoinTypeList() {
    return http.get({
      url: 'financial-admin/config/coin-list'
    });
  },
  createTest(data) {
    return http.post({
      url: '/la/admin/current/test/addLock',
      data,
      dataType: 'form'
    });
  }
};
